var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _c("div", { staticClass: "ai-header-banner" }, [
        _c("div", { staticClass: "banner-overlay" }),
        _c("div", { staticClass: "banner-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "banner-actions" },
            [
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn green-btn",
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: {
                    click: function ($event) {
                      _vm.isOpenAddBrandDialog = true
                    },
                  },
                },
                [_vm._v("\n          Thêm đại lý mới\n        ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Tổng đại lý đã thiết lập"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.totalPage)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Đang hoạt động (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.activeCount)),
            ]),
          ]),
        ]),
        _vm._m(3),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataFilter },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trường học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Tất cả các trường",
                      },
                      on: { change: _vm.getListBrandSchoolAccount },
                      model: {
                        value: _vm.dataFilter.idSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "idSchool", $$v)
                        },
                        expression: "dataFilter.idSchool",
                      },
                    },
                    _vm._l(_vm.schoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          value: item.id,
                          label: `${item.id} - ${item.schoolName}`,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.getListBrandSchoolAccount },
                    },
                    [_vm._v("Tìm kiếm")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table",
                },
              ],
              ref: "multipleTable",
              staticClass: "modern-table",
              attrs: {
                data: _vm.dataTable,
                "element-loading-text": "Đang tải thiết lập đại lý...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
                "max-height": _vm.tableMaxHeight,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tên đại lý",
                  "min-width": "220",
                  prop: "full_name",
                  fixed: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "brand-full-name" }, [
                          _vm._v(_vm._s(row.full_name)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tên trường học",
                  "min-width": "240",
                  prop: "nameSchool",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "school-name-text" }, [
                          _c("i", {
                            staticClass: "el-icon-school",
                            staticStyle: {
                              color: "#64748b",
                              "margin-right": "4px",
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(row.nameSchool) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "ID đại lý trên SePay",
                  "min-width": "160",
                  align: "center",
                  prop: "xid",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("code", { staticClass: "code-badge" }, [
                          _vm._v(_vm._s(row.xid)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tên viết tắt",
                  "min-width": "130",
                  align: "center",
                  prop: "short_name",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "short-name-text" }, [
                          _vm._v(_vm._s(row.short_name)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Trạng thái hoạt động",
                  "min-width": "180",
                  align: "center",
                  prop: "status",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "status-tag-rect",
                            attrs: {
                              type: _vm.getStatusTagType(row.status),
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getStatusLabel(row.status)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Giới hạn học sinh",
                  "min-width": "160",
                  align: "center",
                  prop: "onlinePaymentLimit",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.onlinePaymentLimit
                                ? "danger"
                                : "success",
                              size: "medium",
                              effect: "plain",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.onlinePaymentLimit
                                    ? "Giới hạn"
                                    : "Không giới hạn"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Số học sinh thanh toán",
                  "min-width": "160",
                  align: "center",
                  prop: "numberOnlinePayments",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "payment-count-badge" }, [
                          _vm._v(_vm._s(row.numberOnlinePayments || 0)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  width: "250",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-setting",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.configBrand(row)
                              },
                            },
                          },
                          [_vm._v("\n            Cấu hình\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              size: "mini",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateBrand(row)
                              },
                            },
                          },
                          [_vm._v("\n            Sửa\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper mt-3 flex justify-center" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.dataFilter.page,
                  "page-sizes": _vm.listSizePage,
                  "page-size": _vm.dataFilter.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalPage,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentPageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.dataFilter, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.dataFilter, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddBrandDialogVersion2", {
        attrs: { isOpenAddBrandDialog: _vm.isOpenAddBrandDialog },
        on: { closeDialog: _vm.closeAddBrandDialog },
      }),
      _c("UpdateBrandDialogVersion2", {
        attrs: {
          isOpenUpdateBrandDialog: _vm.isOpenUpdateBrandDialog,
          brand: _vm.brand,
        },
        on: { closeDialog: _vm.closeUpdateBrandDialog },
      }),
      _c("ConfigBrandDialogVersion2", {
        attrs: {
          xid: _vm.xid,
          isOpenConfigBrandDialog: _vm.isOpenConfigBrandDialog,
        },
        on: { closeDialog: _vm.closeConfigBrandDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-office-building" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("DANH SÁCH ĐẠI LÝ CHO TRƯỜNG"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Thiết lập kết nối, cấu hình định danh đại lý đại diện thanh toán SePay cho các trường học."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-folder-opened" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-card purple" }, [
      _c("div", { staticClass: "stat-icon" }, [
        _c("i", { staticClass: "el-icon-link" }),
      ]),
      _c("div", { staticClass: "stat-info" }, [
        _c("p", { staticClass: "stat-label" }, [_vm._v("Cổng kết nối")]),
        _c("h3", { staticClass: "stat-value" }, [_vm._v("SePay API")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }